module.exports = __webpack_public_path__ + "static/media/comment-alt-plus.510f7714.svg";